// src/pages/PolitiqueConfidentialite.jsx
import React from 'react';
import HeaderNormal from '../components/HeaderNormal';

import '../styles/PolitiqueConfidentialite.css';

const PolitiqueConfidentialite = () => {
  return (
    <>
      <HeaderNormal />
      <div className="privacy-container">
        <h1>Politique de confidentialité</h1>
        <p><strong>Dernière mise à jour :</strong> Août 2025</p>

        <h2>1. Qui sommes-nous ?</h2>
        <p>
          Meta Yachts Services est une société spécialisée dans la préparation de bateau, basée en France. 
          Vous pouvez nous contacter à : <a href="mailto:metayachtsservices@gmail.com">metayachtsservices@gmail.com</a>
        </p>

        <h2>2. Données collectées</h2>
        <p>
          Lorsque vous remplissez notre formulaire de contact, nous collectons les informations suivantes :
        </p>
        <ul>
          <li>Nom et prénom</li>
          <li>Adresse e-mail</li>
          <li>Motif de contact</li>
          <li>Message libre</li>
        </ul>

        <h2>3. Finalité de la collecte</h2>
        <p>
          Ces données sont collectées uniquement dans le but de répondre à vos demandes et de vous recontacter si nécessaire.
        </p>

        <h2>4. Durée de conservation</h2>
        <p>
          Vos données sont conservées pendant une durée maximale de 12 mois à compter de notre dernier échange.
        </p>

        <h2>5. Partage des données</h2>
        <p>
          Vos données ne sont jamais vendues ni louées. Elles peuvent être partagées avec notre prestataire de formulaire (Formspree) 
          uniquement pour permettre la transmission de votre message.
        </p>

        <h2>6. Hébergement</h2>
        <p>
          Le site est hébergé par <strong>Render</strong>, qui peut techniquement stocker les journaux de connexion à des fins de sécurité.
        </p>

        <h2>7. Vos droits</h2>
        <p>
          Conformément au RGPD, vous disposez d’un droit d’accès, de rectification, d’opposition et de suppression de vos données personnelles.
          Pour exercer vos droits, envoyez un email à <a href="mailto:metayachtsservices@gmail.com">metayachtsservices@gmail.com</a>.
        </p>

        <h2>8. Cookies</h2>
        <p>
          Ce site n’utilise pas de cookies de suivi ou de publicité.
        </p>

        <h2>9. Sécurité</h2>
        <p>
          Nous mettons en œuvre toutes les mesures techniques raisonnables pour protéger vos données.
        </p>
      </div>

    </>
  );
};

export default PolitiqueConfidentialite;
